import type { Ranking } from '../interfaces/GameScreen'

const RANKING_KEY = '@recycling:ranking'

export function saveRankingInStorage(ranking: Ranking[]) {
	localStorage.setItem(RANKING_KEY, JSON.stringify(ranking))
}

export function getRankingFromStorage(): Ranking[] {
	const data = localStorage.getItem(RANKING_KEY)

	return data ? JSON.parse(data) : []
}
